import { render, staticRenderFns } from "./OutputStudyInformation.vue?vue&type=template&id=36f0afca"
import script from "./OutputStudyInformation.vue?vue&type=script&lang=js"
export * from "./OutputStudyInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports